@if (leasingWarrantySPLoaded) { 
  <div
    class="text-lg md:text-xl font-bold mb-5 mt-14 text-mat-ef-revolution-primary-500"
  >
    <T
      str="Leasing and warranty"
      key="customerPortal.customer-portal.vehicle.leasing-warranty"
      tags="customer-portal, 3.1"
    ></T>
  </div>
}

<mat-divider
  class="relative w-full text-mat-ef-revolution-supergrey-500"
></mat-divider>

<customer-portal-app-skeleton-loader
  [loading]="leasingWarrantySPLoaded"
></customer-portal-app-skeleton-loader>

@if (leasingWarrantySPLoaded) { 
  <mat-expansion-panel
    [hideToggle]="leasingIsDisabled"
    [disabled]="leasingIsDisabled"
    #leasing
    (afterExpand)="
      sendContentModulesData(
        true,
        'customerPortal.customer-portal.vehicle.leasing'
      )
    "
    (afterCollapse)="
      sendContentModulesData(
        false,
        'customerPortal.customer-portal.vehicle.leasing'
      )
    "
  >
    <mat-expansion-panel-header
      class="p-0 md:px-6"
      [collapsedHeight]="'auto'"
      [expandedHeight]="'auto'"
    >
      <mat-panel-title>
        <div class="mt-1 mr-1">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            [ngClass]="leasing.expanded ? 'blue-icon' : ''"
            svgIcon="car_return"
          ></mat-icon>
        </div>
        <div class="vehicle-expansion-panel-text">
          <div
            class="w-full pt-1 overflow-hidden whitespace-nowrap text-ellipsis"
          >
            <div class="flex font-efSans text-sm sm:text-base font-semibold">
              <span>
                @if (isFinancing) { 
                  <T
                    str="Financing"
                    key="customerPortal.customer-portal.vehicle.financing"
                    tags="customer-portal, 3.26"
                  ></T>
                } @else {
                  <T
                    str="Leasing"
                    key="customerPortal.customer-portal.vehicle.leasing"
                    tags="customer-portal, 3.1"
                  ></T>
                }
              </span>
              @if (leasingCalc) { 
                <span
                  class="leasing-title-warning"
                  [ngClass]="styleLeasingProgressBar(leasingCalc)"
                >
                  <mat-icon
                    [svgIcon]="iconType(styleLeasingProgressBar(leasingCalc))"
                  ></mat-icon>
                </span>
              }
            </div>
          </div>
          @if (leasingResponse) { 
            @if (leasingCalc) { 
              <mat-progress-bar
                [ngClass]="styleLeasingProgressBar(leasingCalc)"
                class="h-0.5"
                mode="determinate"
                value="{{ leasingCalc?.percentageLeft.toString() }}"
                dir="rtl"
              >
              </mat-progress-bar>
            } 
            @if (leasingCalc?.tillExpires) { 
              <div class="text-sm text-efSans">
                <T
                  str="The lease expires in {days}."
                  key="customerPortal.customer-portal.leasing-expire"
                  tags="customer-portal, 3.1"
                  [vars]="{ days: leasingCalc.tillExpires }"
                ></T>
              </div>
            } 
            @if (!leasingResponse.startDate || !leasingResponse.endDate) { 
              <div class="text-sm text-efSans">
                <T
                  str="Further leasing information"
                  key="customerPortal.customer-portal.leasing.check-leasing-data"
                  tags="customer-portal, 3.1"
                ></T>
              </div>
            }
          }

          @if (!leasingResponse && !loadingDocuments) { 
            <div class="text-sm text-efSans">
              <T
                str="No leasing data."
                key="customerPortal.customer-portal.leasing.no-leasing-data"
                tags="customer-portal, 3.1"
              ></T>
            </div>
          }
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (leasingResponse) { 
      <div class="ml-5 md:ml-11 mt-2.5 grid grid-cols-1 sm:grid-cols-3 gap-2">
        @if (leasingResponse.providerName) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
            >
              <T
                str="Provider name:"
                key="customerPortal.customer-portal.leasing.provider-name"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.providerName
            }}</span>
          </div>
        } 
        @if (leasingResponse.startDate || leasingResponse.endDate) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
            >
              <T
                str="Maximum duration"
                key="customerPortal.customer-portal.leasing.startEnd"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">
              @if (leasingResponse.startDate) { 
                {{ 'from' | sharedTranslate }} {{ leasingResponse.startDate | date: dateFormat }}
              }
              @if (leasingResponse.endDate) { 
                {{ 'to' | sharedTranslate }} {{ leasingResponse.endDate | date: dateFormat }}
              }
            </span>
          </div>
        } 
        @if (leasingResponse.months) {
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
            >
              <T
                str="Number of months"
                key="customerPortal.customer-portal.leasing.months"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.months
            }}</span>
          </div>
        } 
        @if (leasingResponse.kmLimit) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
              ><T
                str="KM Limit per year"
                key="customerPortal.customer-portal.leasing.kmLimit"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal"
              >{{ leasingResponse.kmLimit }} km</span
            >
          </div>
        } 
        @if (leasingResponse.costPerKm) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
            >
              <T
                str="Cost per additional km"
                key="customerPortal.customer-portal.leasing.costPerKm"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.costPerKm
                | currency: currency:'symbol':'1.2-2':currencyLocale
            }}</span>
          </div>
        } 
        @if (leasingResponse.monthlyRate) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
              ><T
                str="Monthly installment"
                key="customerPortal.customer-portal.leasing.monthlyRate"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.monthlyRate
                | currency: currency:'symbol':'1.2-2':currencyLocale
            }}</span>
          </div>
        } 
        @if (leasingResponse.remainingValue != null) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
              ><T
                str="Remaining value"
                key="customerPortal.customer-portal.leasing.remainingValue"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.remainingValue
                | currency: currency:'symbol':'1.2-2':currencyLocale
            }}</span>
          </div>
        } 
        @if (isFinancing && leasingResponse.residualValue != null) { 
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
              ><T
                str="Residual value"
                key="customerPortal.customer-portal.leasing.residualValue"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.residualValue
                | currency: currency:'symbol':'1.2-2':currencyLocale
            }}</span>
          </div>
        } 
        @if (leasingResponse.number) {
          <div class="m-1 grid">
            <span
              class="text-sm text-efSans font-semibold text-mat-ef-revolution-primary-500"
              ><T
                str="Contract number"
                key="customerPortal.customer-portal.leasing.contractNumber"
                tags="customer-portal, 3.1"
              ></T
            ></span>
            <span class="text-sm text-mat-ef-revolution-primary-500 font-normal">{{
              leasingResponse.number
            }}</span>
          </div>
        }
      </div>

      <div class="relative -r-10 w-full mt-5">
        @if (leasingResponse.source === 'Multilease') {
          <button
            class="w-full mt-2 md:mt-0 md:w-auto float-right ml-0 md:ml-5 revolution"
            mat-button
            mat-flat-button
            color="secondary"
            (click)="openLeasingContactPopup('MultileaseContact')"
          >
            <T
              str="Manage contact"
              key="customerPortal.customer-portal.leasing.manage.contact"
              tags="customer-portal, 3.1"
            ></T>
          </button>
        } 
        @if (hasLeasingExtensionPopup) { 
          <button
            class="w-full md:w-auto float-right mt-2 md:mt-0 revolution"
            mat-button
            mat-flat-button
            color="secondary"
            (click)="openLeasingContactPopup('Contact')"
          >
            <T
              str="Lease extension"
              key="customerPortal.customer-portal.leasing-extension.contact"
              tags="customer-portal, 3.1"
            ></T>
          </button>
        } 
        @if (hasLeasingDocuments) { 
          <button
            [routerLink]="['/vehicles/' + vehicle.vin + '/vehicle-history/leasing']"
            class="w-full mt-2 md:mt-0 md:w-auto float-right revolution mr-0 md:mr-5"
            mat-button
            mat-stroked-button
            color="secondary"
            (click)="onLeasingDocumentButtonClicked()"
          >
            {{ 'documents' | sharedTranslate }}
          </button>
        }
      </div>
    }
  </mat-expansion-panel>
}

<mat-divider
  class="relative w-full text-mat-ef-revolution-supergrey-500"
></mat-divider>

@if (hasWarranty && featuresWarranty && enableEfitData) { 
  @if (leasingWarrantySPLoaded) { 
    <customer-portal-app-revolution-warranty-molecule [vehicle]="vehicle">
    </customer-portal-app-revolution-warranty-molecule>
  }

  <customer-portal-app-skeleton-loader
    [loading]="leasingWarrantySPLoaded"
  ></customer-portal-app-skeleton-loader>

  <mat-divider
    class="relative w-full text-mat-ef-revolution-supergrey-500"
  ></mat-divider>
}
